// extracted by mini-css-extract-plugin
export default {"item":"OrdersScreen_item__30x7X","tabTitle":"OrdersScreen_tabTitle__+WrY+","tabContainer":"OrdersScreen_tabContainer__wS+Ll","tabColumn":"OrdersScreen_tabColumn__TEdYK"};